import {
    READ_NOTIFICATIONS_REQUEST,
    READ_NOTIFICATIONS_SUCCESS,
    READ_NOTIFICATIONS_ERROR
  } from "./ReadNotificationTypes";
  
  const initialState = {
    loading: false,
    error: "",
    readNotification: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case READ_NOTIFICATIONS_REQUEST:
        return {
          ...state,
          loading: true
        };
      case READ_NOTIFICATIONS_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          readNotification: action.payload,
          error: ""
        };
      case READ_NOTIFICATIONS_ERROR:
        return {
          ...state,
          loading: false,
          readNotification: [],
          error: action.payload
        };
      default:
        return state;
    }
  };
  